<template>
  <v-container>
    <v-card-title>
      <EditableField
        :value="accountData.name"
        label="Account Name"
        :editing="editMode"
        key-path="name"
        :hide-label="true"
        @save="handleFieldSave"
      >
        <template #value>
          <h1>{{ accountData.name }}</h1>
        </template>
      </EditableField>
    </v-card-title>

    <v-btn class="float-sm-right mt-2 mx-2" @click="toggleEdit">
      <v-icon>{{ editMode ? 'mdi-content-save' : 'mdi-account-edit' }}</v-icon>
      {{ editMode ? 'Save' : 'Edit' }}
    </v-btn>

    <v-btn
      class="btn-sm float-sm-right mt-2 mx-2"
      v-if="editMode"
      text
      @click="cancelEdit"
    >
      Cancel
    </v-btn>
    <h2>Account Details</h2>
    <v-divider></v-divider>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="4" cols-sm="12">
            <v-list-item>
              <v-list-item-content>
                <EditableField
                  :value="accountData.email"
                  label="Email"
                  :editing="editMode"
                  key-path="email"
                  @save="handleFieldSave"
                />
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="4" cols-sm="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Created</v-list-item-title>
                <v-list-item-subtitle>{{
                  formatDate(account.created_at)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="4" cols-sm="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Last updated</v-list-item-title>
                <v-list-item-subtitle>{{
                  formatDate(account.updated_at)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-container>
</template>

<script>
  import EditableField from '@/components/EditableField.vue'

  export default {
    name: 'AccountMetaInfo',
    components: {
      EditableField,
    },
    props: {
      account: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        editMode: false,
        accountData: {},
      }
    },
    watch: {
      account: {
        immediate: true,
        handler(newVal) {
          this.accountData = { ...newVal }
        },
      },
    },
    methods: {
      formatDate(date) {
        return new Date(date).toLocaleDateString()
      },
      toggleEdit() {
        if (this.editMode) {
          this.$emit('save', this.accountData)
        } else {
          this.accountData = { ...this.account }
        }
        this.editMode = !this.editMode
      },
      cancelEdit() {
        this.accountData = { ...this.account }
        this.editMode = false
      },
      handleFieldSave(data) {
        this.accountData[data.keyPath] = data.value
      },
    },
  }
</script>
